<template>
  <div class="container">
    <a-tabs @tabClick="tabClick" class="tabs" v-model:activeKey="activeTabKey">
      <a-tab-pane :key="tab.component" :tab="tab.label" v-for="tab in tabs">
        <component class="component" mode="" :is="component[tab.component]" :ref="tab.ref" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script setup>
import { reactive, ref, defineAsyncComponent, markRaw, nextTick, computed, watch } from 'vue'
import { useStore } from 'vuex'
const store = useStore()
const targetWorkOrder = computed(() => store.state.workOrder.workOrderGroupInfo?.targetWorkOrder) // 院内随访是否展示
const groupType = computed(() => store.state.workOrder.workOrderGroupInfo.groupType)
const activeTabKey = computed(() => store.state.app.tabActivekey)

watch(
  () => targetWorkOrder.value,
  val => {
    // 随访任务工单跳转到院内随访
    if (val?.businessType === 40) {
      store.commit('app/SET_TABS_ACTIVE', 'followUp')
    }
  },
  { deep: true, immediate: true }
)
const initTabs = [
  { show: true, label: '聊天', component: 'Chat', ref: 'messageList' },
  { show: true, label: '问诊', component: 'consult', ref: 'consult' },
  {
    show: true,
    label: '病历',
    component: 'medicalRecord',
    ref: 'medicalRecord'
  },
  { show: true, label: '处方', component: 'prescription', ref: 'prescription' },
  { show: true, label: '量表', component: 'gauge', ref: 'gauge' },
  { show: true, label: '随访', component: 'visits', ref: 'visits' },
  { show: true, label: '预约', component: 'appoint', ref: 'appoint' },
  { label: '小结', component: 'summary', ref: 'summary' },
  { label: '通话记录', component: 'CallLog', ref: 'callLog' },
  { label: '短信记录', component: 'SMS', ref: 'sms' },
  { label: '院内随访', component: 'followUp', ref: 'followUp' }
]
let tabs = []
switch (groupType.value) {
  // case 3:
  //   tabs = ref([...initTabs]) // 1.8导诊群放开限制
  //   break
  case 4:
    tabs = ref([initTabs[0], initTabs[8], initTabs[9]])
    break
  default:
    // 是否展示院内随访
    if (!targetWorkOrder.value?.insideHospitalFlag) {
      initTabs.splice(
        initTabs.indexOf(item => item.label === '院内随访'),
        1
      )
    }
    tabs = ref([...initTabs])
    break
}
const component = reactive({
  activeKey: 'Chat',
  gauge: markRaw(defineAsyncComponent(() => import('./Gauge'))),
  medicalRecord: markRaw(defineAsyncComponent(() => import('./MedicalRecord/index.vue'))),
  prescription: markRaw(defineAsyncComponent(() => import('./Prescription/index.vue'))),
  Chat: markRaw(defineAsyncComponent(() => import('./chat/index.vue'))),
  visits: markRaw(defineAsyncComponent(() => import('./Visits/index.vue'))),
  appoint: markRaw(defineAsyncComponent(() => import('./Appoint/index.vue'))),
  consult: markRaw(defineAsyncComponent(() => import('./Consult/index.vue'))),
  summary: markRaw(defineAsyncComponent(() => import('./Summary/index.vue'))),
  CallLog: markRaw(defineAsyncComponent(() => import('./CallLog/index.vue'))),
  SMS: markRaw(defineAsyncComponent(() => import('./SMS/index.vue'))),
  followUp: markRaw(defineAsyncComponent(() => import('./FollowUp/index.vue')))
})
/**
 * @description: 每次点击不同tabs时候重新刷新该页面
 * @param {string} oneComponent 某个tab的组件名称（唯一）
 */
function tabClick(oneComponent) {
  const tab = tabs.value.find(tab => tab.component === oneComponent)
  store.commit('app/SET_TABS_ACTIVE', oneComponent)
  tab.show = false
  nextTick(() => (tab.show = true))
}
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  background: white;

  .tabs {
    position: absolute;
    width: 100%;

    ::v-deep(.ant-tabs-bar) {
      margin-bottom: 0;
    }

    ::v-deep(.ant-tabs-tab) {
      margin-right: 88px;
      // height: 60px;
      // line-height: 36px;
    }

    ::v-deep(.ant-tabs-tab:first-child) {
      margin-left: 44px;
    }

    ::v-deep(.ant-tabs-tabpane) {
      background: #f0f2f5;
      //!NOTE: 每个tab页高度设置死不设置的话 超出部分会出现滚动条，避免滚动条出现（一屏幕）
      height: calc(100vh - 96px);
      overflow: auto;
    }
  }
}
</style>
